import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Button, Tab, Tabs } from '@mui/material'
import React, { ReactElement, useEffect, useState } from 'react'
import { routes } from '../../pages/routes'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { Add } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { setRiderModal, setShoeingModal, setTrackLibraryModal, setTrackModal, setTrackNameModal, setTrainingTypeModal } from '../../store/reducers/modal.reducer'
import { Icon } from '@iconify/react'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { TBilling } from '../../shared/types/billing.type'
import { isEmpty, isUndefined } from 'lodash'
import { useQuery } from 'react-query'
import { User } from '../../api/user'
import { useAuth } from '../../hooks/useAuth'

function ProfileTabs({ children, onRouteChanged }: { children: ReactElement, onRouteChanged: (path: string | undefined, element: React.ReactNode) => void }) {
    const billings = useSelector<RootState>(state => state.user.user?.user_billing_infos) as TBilling[]
    const { auth, isAdmin } = useAuth()

    const institueQuery = useQuery(['arioneo_institue'], () => User.getArioneoInstitue(auth?.id))

    const location = useLocation()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [value, setValue] = useState('1')

    const institue_url = institueQuery.data?.data.url

    const tabs = [
        // {
        //     title: "navbar:profileOptions:profile",
        //     value: routes.DASHBOARD_ROUTES.PROFILE,
        //     disabled: false,
        //     index: '1',
        //     children: null,
        //     isExternal: false,
        // },
        {
            title: "navbar:generalSettings",
            value: routes.DASHBOARD_ROUTES.SETTINGS,
            disabled: false,
            index: '2',
            children: null,
            isExternal: false,
        },
        {
            title: "navbar:myTrainings",
            value: routes.DASHBOARD_ROUTES.MYTRAININGS,
            disabled: false,
            index: '3',
            children: null
        },
        // {
        //     title: "navbar:analyticsSettings",
        //     value: routes.DASHBOARD_ROUTES.MYANALYTICS,
        //     disabled: false,
        //     index: '4',
        //     children: null
        // },
        {
            title: 'qualification:title',
            value: routes.DASHBOARD_ROUTES.TRACKS,
            disabled: false,
            index: '5',
            children: null
        },
        // {
        //     title: 'subscription:location',
        //     value: routes.DASHBOARD_ROUTES.EQUIMETRES,
        //     disabled: false,
        //     index: '4',
        //     children: null
        // },
        {
            title: "sendTrainingsConfigurations:menuKey",
            value: routes.DASHBOARD_ROUTES.NOTIFICATIONS,
            disabled: false,
            index: '6',
        },
        // ...(isEmpty(billings) ? [] : [{
        //     title: "menu:billing",
        //     value: routes.DASHBOARD_ROUTES.BILLINGS,
        //     disabled: false,
        //     index: '7',
        // }]),
        // {
        //     title: "Arioneo Institute",
        //     value: institue_url,
        //     disabled: institueQuery.isLoading || institueQuery.isFetching || !institue_url,
        //     isExternal: true,
        //     index: '8',
        // },
        {
            title: "onboarding:title",
            value: routes.DASHBOARD_ROUTES.ONBOARDING,
            disabled: !isAdmin,
            index: '9',
        },
    ]

    useEffect(() => {
        let { pathname } = location

        let route = tabs.find(tab => tab.value === pathname)
        onRouteChanged(route?.title, route?.children)
        if (route) {
            setValue(route.index)
        } else {
            if (pathname.includes('qualifications')) {
                setValue('5')
            }
        }
    }, [location.pathname])


    const handleChange = (event: React.SyntheticEvent, newValue: string) => {


        let route = tabs.find(tab => tab.index === newValue)

        if (route) {
            if (!route?.isExternal) {
                let path = route.value
                path && navigate(path)
            } else {
                window.open(route.value, '_blank');

            }
        }

    };

    return (
        <Box sx={{ width: '100%', typography: 'body1', mt: 2, position: 'relative', flex: 1 }}>
            <TabContext value={value}>
                <Tabs
                    variant="scrollable"
                    scrollButtons='auto'
                    value={value}
                    onChange={handleChange}>
                    {tabs.map((tab, i) => (
                        tab.disabled ? null : <Tab key={tab.index} disabled={tab.disabled} label={t(tab.title)} value={tab.index} />
                    ))}
                </Tabs>
                <TabPanel value={value} sx={{ p: 0, m: 0, mt: 2, position: 'relative' }}>
                    {children}
                </TabPanel>
            </TabContext>

        </Box>
    )
}

export default ProfileTabs